export default class HandlerErrorMessages {
    getErrorMessage(e) {
        if(e.extensions.validation) {
            if(e.extensions.validation.google_id) {
                return e.extensions.validation.google_id[0]
            } if (e.extensions.validation.domain) {
                return e.extensions.validation.domain[0]
            } if (e.extensions.validation.website_id) {
                return e.extensions.validation.website_id[0]
            } if (e.extensions.validation.email) {
                return e.extensions.validation.email[0]
            }
        } else {
            return e.message
        }
    }
}
